export const LEAD_COMPLETE = 'LEAD_COMPLETE';
export const LEAD_COMPLETE_PENDING = `${LEAD_COMPLETE}_PENDING`;
export const LEAD_COMPLETE_FAILED = `${LEAD_COMPLETE}_FAILED`;
export const LEAD_COMPLETE_SUCCESS = `${LEAD_COMPLETE}_SUCCESS`;
export const LEAD_COMPLETE_FAILURE = `${LEAD_COMPLETE}_FAILURE`;
